import { inject, Injectable } from '@angular/core';
import { EnvService } from '@zb/services/src/services/env.service';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class StudioCommonService {
  constructor(
    private envService: EnvService
  ) { }

  encryptDetails = (data: string | number) => {
    const text = CryptoJS.AES.encrypt(
      data.toString(),
      this.envService.getEnvironment()?.secretKey
    ).toString();
    return text.replace(/\\/g, '|');
  };
  /**
   * function for decrypting the secured details
   * @param data which is used to get the data
   */
  decryptDetails = (data: string) => {
    if (data) {
      const bytes = CryptoJS.AES.decrypt(
        data.toString(),
        this.envService.getEnvironment()?.secretKey
      );
      const result = bytes.toString(CryptoJS.enc.Utf8).replace(/\|/g, '\\');
      // const result = bytes.toString(CryptoJS.enc.Utf8).replace('|', /\\/g);
      return result;
    } else {
      return null;
    }
  };

  // Method to set a cookie
  setCookie(key:string, value:string, expireSeconds:number) {
    const date = new Date();
    date.setTime(date.getTime() + (expireSeconds * 1000)); // Convert seconds to milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}; ${expires}; path=/`;
  }

  // Method to get a cookie by key
  getCookie(key:string) {
    const decodedCookies = decodeURIComponent(document.cookie).split(';');
    const nameEQ = encodeURIComponent(key) + "=";
    for (let cookie of decodedCookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length);
      }
    }
    return null;
  }

  // Remove a cookie by key
  removeCookie(key:string) {
    document.cookie = `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
